module.exports = __webpack_public_path__ + "img/scroll-to-top.7bfcfb40.svg";